<div class="row p-b-10 js-hide-on-fullscreen">
	<div class="col-sm-12">
		<h4 id="ct-schema-heading" class="page-title">{{TR "Anlagenschema"}}{{#if schema}} <small>({{schema}})</small>{{/if}}</h4>
	</div>
</div>
{{> WARNING_HINTS}}
<div id="schema-controls" class="m-b-5 hidden">
	{{#if isEditMode}}
		<div class="btn-group">
			<button id="js-back" class="btn btn-sm btn-primary">
				{{TR "Fertig"}}
			</button>
		</div>
		{{#if canResetScheme}}
		<div class="btn-group">
			<button id="js-reset" class="btn btn-sm btn-white" >
				{{TR "Zurücksetzen"}}
			</button>
		</div>
		{{/if}}
	{{/if}}
	{{#unless isEditMode}}
		<div class="btn-group">
			<button id="js-refresh" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Refresh"}}">
				<i class="fa fa-refresh"></i>
			</button>
			<button id="js-toggle-auto-refresh" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Auto-Refresh"}}">
				<i class="fa fa-history"></i>
			</button>
			{{#if showLegend}}
			<button id="js-toggle-legend" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Legende ein/ausblenden"}}">
				<i class="fa fa-tasks"></i>
			</button>
			{{/if}}
		</div>
		<div class="btn-group">
			<button id="js-zoom-out" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Verkleinern"}}">
				<i class="fa fa-search-minus"></i>
			</button>
			<button id="js-zoom-in" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Vergrößern"}}">
				<i class="fa fa-search-plus"></i>
			</button>
			<button id="js-zoom-reset" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Zoom zurücksetzen"}}">
				<i class="fa fa-search"></i>
			</button>
			<button id="js-toggle-fullscreen" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Vollbild"}}">
				<i class="fa fa-arrows-alt"></i>
			</button>
		</div>
		<div class="btn-group">
			<button id="js-show-actual-values" class="btn btn-sm btn-primary btn-selected" data-toggle="tooltip" data-placement="bottom" title="{{TR "Ist-Werte anzeigen"}}">
				{{TR "Ist-Werte"}}
			</button>
			<button id="js-show-set-point-values" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Soll-Werte anzeigen"}}">
				{{TR "Soll-Werte"}}
			</button>
		</div>
		{{#if quickAnalysisAvailable}}
		<div class="btn-group dropdown">
			<button class="btn btn-sm btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
				<i class="fa fa-bar-chart-o"></i>&nbsp;<span class="caret"></span>
			</button>
			<ul class="dropdown-menu dropdown-menu-left">
				{{#each quickAnalysisInfo}}
				<li>
					<a href="{{link}}" class="btn dropdown-button">{{name}}</a>
				</li>
				{{/each}}
			</ul>
		</div>
		{{/if}}
		{{#if canEditScheme}}
			<div class="btn-group">
			<button id="js-edit-scheme" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom"
				title="{{TR "Bearbeiten"}}">
				<i class="glyphicon glyphicon-pencil"></i>
			</button>
		</div>
		{{/if}}
		{{#each hints}}
			<div id="{{this.id}}" class="btn-group m-l-10" style="display:none">
				<i class="{{this.icon}} m-r-5"></i>{{this.message}}
			</div>
		{{/each}}
	{{/unless}}
</div>

<div class="row">
	<div class="col-xs-12 {{#if showSensors}}col-sm-8 col-md-9{{/if}}">
		<div id="tabs-region"></div>
		<div id="schema-region"></div>
	</div>
	<div id="sidebar-region"></div>
</div>
